<template>
	<t-popover
		:showPopover="popoverIsVisible"
		:marginY="12"
		:marginX="10"
		:style="getStyle"
		direction="bottom"
		:min-width="150"
		relative
	>
		<div slot="target" class="header-select-wrapper">
			<span class="header-content">
				<slot/>
			</span>
			<t-icon-button
				type="bp"
				icon="caret-down"
				appearance="transparent"
				iconSize="sm"
				@click="togglePopover"
			/>
			<t-icon-button
				type="bp"
				icon="cross"
				appearance="transparent"
				iconSize="sm"
				style="margin-left: auto"
				@click="onToggleFilters"
			/>
		</div>

		<t-menu v-if="items">
			<t-menu-options-group
				:title="title"
				:items="items"
				:selectedItem="selectedItem"
				groupStyle="combobox"
				@change="onChange"
			>
				<template v-slot="slotProps">
					<t-menu-combobox-option-item
						:value="slotProps.item"
						:selected="slotProps.item.id != -1 && slotProps.isSelected"
					>
						<slot name="menuitemlabel" :item="slotProps.item">{{ slotProps.item.label }}</slot>
					</t-menu-combobox-option-item>
				</template>
			</t-menu-options-group>
		</t-menu>
	</t-popover>
</template>

<script>
import formMixin from '@/components/evergreen/inputs/formMixin';
import popoverMixin from '@/components/evergreen/inputs/popoverMixin';
import TIconButton from '@/components/evergreen/buttons/TIconButton';

export default {
	name: 'OrderSearchFiltersHeader',
	components: { TIconButton },
	mixins: [ formMixin, popoverMixin ],
	props: {
		items: Array,
		title: String,
		selectedItem: Object,
		color: { type: String, default: 'blue' },
		defaultLabel: String
	},
	computed: {
		panelHeaderIcon() {
			return this.selectedItem && this.selectedItem.id !== -1 ? 'filter-list' : 'search';
		},
	},
	methods: {
		onChange(value) {
			this.popoverSetHidden();
			this.$emit('change', value);
		},
		togglePopover() {
			this.popoverToggle();
		},
		onToggleFilters() {
			this.$emit('toggleFilters');
		},
	}
};
</script>

<style lang="scss" scoped>
	@import '~@/components/evergreen/scss/colors';
	@import '~@/components/evergreen/scss/text';
	.header-select-wrapper {
		display: flex;
		align-items: center;
		padding: 0px 10px;
	}

	.header-content {
		@extend %font-families-ui;
		@extend %text-medium;
		color: get-color($text, 'default');
		font-weight: 500;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		margin: 0px 8px;
		user-select: none;
	}

</style>
